var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCountStock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33.638 16.456",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2268",
    "data-name": "Path 2268",
    d: "M6.151,23V10.416l-2.97,1.826v-3.3L6.151,7.16H9.209V23Zm6.8-.022v-2.6l6.644-5.9a4.644,4.644,0,0,0,1.056-1.243,2.349,2.349,0,0,0,.308-1.089,2.742,2.742,0,0,0-.3-1.293,2.225,2.225,0,0,0-.836-.891,2.4,2.4,0,0,0-1.265-.325,2.547,2.547,0,0,0-1.337.347,2.46,2.46,0,0,0-.9.913,2.3,2.3,0,0,0-.3,1.226h-3.08a5.358,5.358,0,0,1,.715-2.816,4.822,4.822,0,0,1,1.991-1.837,6.467,6.467,0,0,1,2.97-.649,5.654,5.654,0,0,1,2.778.677,4.972,4.972,0,0,1,1.931,1.886,5.476,5.476,0,0,1,.7,2.805,5.01,5.01,0,0,1-.33,1.953,4.568,4.568,0,0,1-.979,1.43q-.649.655-1.6,1.479l-4.29,3.762-.242-.66h7.436v2.816Zm18.348.308a5.524,5.524,0,0,1-2.266-.478,5.606,5.606,0,0,1-1.875-1.348,5.064,5.064,0,0,1-1.139-2.046l2.9-.77a2.318,2.318,0,0,0,.907,1.347,2.491,2.491,0,0,0,1.469.478,2.436,2.436,0,0,0,1.248-.33,2.5,2.5,0,0,0,.9-.891,2.376,2.376,0,0,0,.335-1.243,2.451,2.451,0,0,0-.7-1.755A2.363,2.363,0,0,0,31.3,15.52a2.184,2.184,0,0,0-.638.093,2.832,2.832,0,0,0-.594.259l-1.342-2.354,5.038-4.18.22.638H26.633V7.16h9.9V9.976L32.617,13.76l-.022-.836A4.726,4.726,0,0,1,36.329,15.7a5.533,5.533,0,0,1,.49,2.3A4.906,4.906,0,0,1,36.06,20.7a5.6,5.6,0,0,1-4.763,2.59Z",
    transform: "translate(-3.181 -6.83)",
    fill: "#00246a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountStock);
export default __webpack_public_path__ + "static/media/CountStock.d49558b9eceb3239ca2b207379397653.svg";
export { ForwardRef as ReactComponent };